import { EvaluateCompany } from "./EvaluateCompany";
import { ViewProfileCompany } from "./ViewProfileCompany";

export const CompanyActions = ({
    company,
    isLoading,
    onApprove,
    onSelect
}) => {
    return (
        <>
            <EvaluateCompany
                company={company}
                isLoading={isLoading}
                onApprove={onApprove}
                onSelectForDisapprove={onSelect}
            />

            <ViewProfileCompany
                companyId={company.id}
                onSelect={onSelect}
            />
        </>
    );
};
